<script setup lang="ts">
import { Plug } from '@lucide/vue';
import FeatureAvailabilityBadge from '@/components/marketing/shared/FeatureAvailabilityBadge.vue';
import SectionHeading from '@/components/marketing/shared/SectionHeading.vue';
import PlatformIcon from '@/components/marketing/shared/PlatformIcon.vue';
import type { PlatformKey } from '@/components/marketing/shared/platforms';

const integrations: {
    platform: PlatformKey;
    status: 'planned' | 'coming-soon';
}[] = [
    { platform: 'instagram', status: 'planned' },
    { platform: 'facebook', status: 'planned' },
    { platform: 'youtube', status: 'planned' },
    { platform: 'linkedin', status: 'planned' },
    { platform: 'tiktok', status: 'planned' },
    { platform: 'website', status: 'coming-soon' },
    { platform: 'x', status: 'coming-soon' },
    { platform: 'pinterest', status: 'coming-soon' },
    { platform: 'threads', status: 'coming-soon' },
];
</script>

<template>
    <section id="integrations" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Integrations"
                title="The channels your customers already use."
                description="We are building the first connections now and will label each one honestly as it becomes available."
            />

            <ul class="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                <li
                    v-for="item in integrations"
                    :key="item.platform"
                    class="bg-card border-border flex items-center justify-between gap-3 rounded-xl border p-4"
                >
                    <PlatformIcon
                        :platform="item.platform"
                        class="border-0 bg-transparent p-0"
                    />
                    <FeatureAvailabilityBadge :status="item.status" />
                </li>
            </ul>

            <p
                class="text-muted-foreground mt-8 flex items-start gap-2 text-sm"
            >
                <Plug class="mt-0.5 size-4 shrink-0" aria-hidden="true" />
                Connecting an account is always your choice, and you can
                disconnect it at any time. Supported features depend on what
                each platform allows.
            </p>
        </div>
    </section>
</template>
